<template>
  <div>
    <div>
      <p class="contentType">
        <span>Condition Type:</span>
        <span>{{ formName }}</span>
      </p>
    </div>
    <el-form :model="form" :rules="rules" ref="form">
      <el-row :gutter="24">
        <el-col :span="12">
          <el-form-item
            label="Covenants compliance certificate within days:"
            prop="covenantsComplianceCertificateWithinDays"
          >
            <el-input
              style="width: 300px"
              onkeyup="value=value.replace(/[^\d]/g,'')"
              v-model="form.covenantsComplianceCertificateWithinDays"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="After financial closing:"
            prop="afterFinancialClosing"
          >
            <el-select v-model="form.afterFinancialClosing">
              <el-option
                v-for="option in options"
                :label="option.label"
                :value="option.value"
                :key="option.value"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <common-form ref="commonForm" :defaultData="_commonData"></common-form>
  </div>
</template>

<script>
import CommonForm from './common-form'
export default {
  components: { CommonForm },
  data() {
    const options = [
      { value: 1, label: 'annually' },
      { value: 2, label: 'half yearly' },
      { value: 3, label: 'quarterly' },
    ]
    return {
      options,
      formName: 'CERT',
      commonFormData: {},
      form: {
        covenantsComplianceCertificateWithinDays: '',
        afterFinancialClosing: '',
      },
      rules: {
        covenantsComplianceCertificateWithinDays: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
        afterFinancialClosing: [
          { required: true, message: 'can not be empty!', trigger: 'blur' },
        ],
      },
    }
  },
  computed: {
    _commonData() {
      return {
        ...this.commonFormData,
      }
    },
  },
  watch: {
    d_value: {
      deep: true,
      immediate: true,
      handler(newValue) {
        this.commonFormData = newValue
        this.$set(
          this.form,
          'covenantsComplianceCertificateWithinDays',
          newValue.covenantsComplianceCertificateWithinDays,
        )
        this.$set(
          this.form,
          'afterFinancialClosing',
          newValue.afterFinancialClosing,
        )
      },
    },
  },
  props: {
    d_value: {
      type: Object,
      default: () => {},
    },
  },
  methods: {
    getFormData() {
      return {
        ...this.form,
        formName: this.formName,
        ...this.$refs.commonForm.getCommonForm(),
      }
    },
    async checkValid() {
      const valid = await this.$refs.form.validate()
      if (valid) {
        return await this.$refs.commonForm.checkCommonValid()
      } else {
        return false
      }
    },
  },
}
</script>

<style scoped lang="less">
.contentType {
  margin-bottom: 10px;

  span {
    font-size: 14px;
    font-weight: bold;
    color: #303133;
    &:first-child {
      margin-right: 10px;
    }
  }
}
</style>
